import { useLocation } from 'react-router-dom';

/** Architrave가 운영하는 페이지(랜딩/정책/가이드/어드민/온보딩)이면 true. 유저 개인 archive가 아님 */
export const useIsFromArchitrave = (): boolean => {
  const { pathname } = useLocation();
  const operatedPaths = ['/', '/policy', '/guide', '/admin', '/onboard', '/exhibitions'] as const;
  return operatedPaths.some((p) =>
    p === '/' ? pathname === '/' : pathname.startsWith(p)
  );
};
